export const Items: import('../../../sim/dex-items').ModdedItemDataTable = {
	kommoniumz: {
		inherit: true,
		isNonstandard: "Future",
	},
	lunaliumz: {
		inherit: true,
		isNonstandard: "Future",
	},
	lycaniumz: {
		inherit: true,
		isNonstandard: "Future",
	},
	mimikiumz: {
		inherit: true,
		isNonstandard: "Future",
	},
	solganiumz: {
		inherit: true,
		isNonstandard: "Future",
	},
	ultranecroziumz: {
		inherit: true,
		isNonstandard: "Future",
	},
};
